<template>
    <div class="poi-nearby">
        <div class="sidebar__section sidebar__section--border-top-huge">
            <div class="poi-nearby__title caption-light">Webcams in der Nähe</div>
        </div>
        <div>
            <POIList :pois="nearby" current-sorting="DISTANCE_ASC" />
        </div>
    </div>
</template>

<script>
import POIList from '@/components/POIList.vue'

export default {
    components: {
        POIList
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
    },
    computed: {
        nearby() {
            return { 'traffic': this.poi.nearbyPOIs }
        },
        parentPoi() {
            return {
                id: this.poi.id,
                type: 'traffic',
                subType: false,
                showingMapPins: false,
            }
        }
    },
    mounted() {
        // in case camera is clicked
        this.$store.commit('setPreviousActivePoi', this.parentPoi)
    },
}
</script>

<style lang="scss">
.poi-nearby {
    margin-top: 24px;

    &__title {
        margin: 24px 0 7px
    }
}
</style>